// hooks/useCountries.ts
import { useState, useEffect } from 'react';
import { API_URL } from '../config';
export interface Country {
  id: number;
  name: string;
  code: string;
}

export const useCountries = () => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        // Vous devrez créer cette API ou utiliser une liste statique
        const response = await fetch(`${API_URL}/list-countries`);
        const data = await response.json();
        setCountries(data.data || []);
      } catch (err) {
        console.error('Error fetching countries:', err);
        setError('Failed to load countries');
        // Liste de secours
        setCountries([
          { id: 1, name: 'United Arab Emirates', code: 'AE' },
          { id: 2, name: 'Saudi Arabia', code: 'SA' },
          { id: 3, name: 'United States', code: 'US' },
          { id: 4, name: 'United Kingdom', code: 'GB' },
          { id: 5, name: 'France', code: 'FR' },
          { id: 6, name: 'Germany', code: 'DE' },
          { id: 7, name: 'India', code: 'IN' },
          { id: 8, name: 'Pakistan', code: 'PK' },
          { id: 9, name: 'Egypt', code: 'EG' },
          { id: 10, name: 'Morocco', code: 'MA' },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  return { countries, loading, error };
};